interface Props {
  error: unknown;
  className?: string;
}

export function ErrorMessage({ error, className = '' }: Props) {
  const message = resolveMessage(error);
  return (
    <div className={`text-sm ${className}`} style={{ color: 'var(--loss)' }}>
      {message}
    </div>
  );
}

/**
 * Coerce whatever was thrown/stored into a human message. Handles the cases callers actually pass:
 * a plain string (some components store `e.message`), an Error (incl. our ApiError, whose `message`
 * already prefers the server's ProblemDetails detail), and a raw ProblemDetails-shaped object.
 * Falls back to a generic line only when nothing usable is present.
 */
function resolveMessage(error: unknown): string {
  if (typeof error === 'string' && error.trim()) return error;
  if (error instanceof Error && error.message.trim()) return error.message;
  if (error && typeof error === 'object') {
    const p = error as { detail?: unknown; title?: unknown; message?: unknown };
    if (typeof p.detail === 'string' && p.detail.trim()) return p.detail;
    if (typeof p.title === 'string' && p.title.trim()) return p.title;
    if (typeof p.message === 'string' && p.message.trim()) return p.message;
  }
  return 'Something went wrong.';
}
